import {useEffect, useState, useMemo, useCallback} from 'react';
import {
  XMarkIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from '@heroicons/react/24/outline';
import {NewsletterSignUpPopup} from '../popups';

export function NewsFlashBanner({isHome}) {
  const [isVisible, setIsVisible] = useState(true);
  const [showNewsletterPopup, setShowNewsletterPopup] = useState(false);
  const [isPaused, setIsPaused] = useState(false);

  const handleClose = () => {
    setIsVisible(false);
  };

  const messages = useMemo(
    () => [
      {
        message: 'ENJOY TWO COMPLIMENTARY SAMPLES WITH EACH PURCHASE',
        openModal: false,
      },
      {
        message: 'SIGN UP TO RECEIVE 10% OFF YOUR NEXT ORDER',
        openModal: true,
      },
      {
        message: 'FREE SHIPPING ON ALL UK ORDERS',
        openModal: false,
      },
    ],
    [],
  );

  const [currentMessage, setCurrentMessage] = useState(messages[0]);

  const cycleMessage = useCallback(() => {
    setCurrentMessage(
      messages[(messages.indexOf(currentMessage) + 1) % messages.length],
    );
  }, [messages, currentMessage]);

  useEffect(() => {
    if (!isPaused) {
      const interval = setInterval(cycleMessage, 5000);
      return () => clearInterval(interval);
    }
  }, [isPaused, cycleMessage]);

  const handleMouseEnter = () => {
    setIsPaused(true);
  };

  const handleMouseLeave = () => {
    setIsPaused(false);
  };

  const handlePrevMessage = () => {
    const currentIndex = messages.indexOf(currentMessage);
    const newIndex = (currentIndex - 1 + messages.length) % messages.length;
    setCurrentMessage(messages[newIndex]);
  };

  const handleNextMessage = () => {
    const currentIndex = messages.indexOf(currentMessage);
    const newIndex = (currentIndex + 1) % messages.length;
    setCurrentMessage(messages[newIndex]);
  };

  const handleMessageClick = () => {
    if (currentMessage.openModal) {
      setShowNewsletterPopup(true);
    }
  };

  if (!isVisible || !isHome) return null;

  return (
    <>
      <div className="bg-black w-full h-[48px] relative flex items-center justify-center">
        <div className="container mx-auto flex items-center justify-center relative px-4">
          <div
            className="flex items-center gap-4 max-w-2xl w-full justify-center"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <button
              onClick={handlePrevMessage}
              className="hover:opacity-75 transition-opacity"
              aria-label="Previous message"
            >
              <ChevronLeftIcon className="w-4 h-4 text-white" />
            </button>
            {currentMessage.openModal ? (
              <button
                onClick={handleMessageClick}
                className="hover:opacity-75 transition-opacity cursor-pointer"
              >
                <h6 className="uppercase super-tracking font-semibold text-xs md:text-sm text-white text-center">
                  {currentMessage.message}
                </h6>
              </button>
            ) : (
              <h6 className="uppercase super-tracking font-semibold text-xs md:text-sm text-white text-center">
                {currentMessage.message}
              </h6>
            )}
            <button
              onClick={handleNextMessage}
              className="hover:opacity-75 transition-opacity"
              aria-label="Next message"
            >
              <ChevronRightIcon className="w-4 h-4 text-white" />
            </button>
          </div>
        </div>
        <button onClick={handleClose} className="absolute right-4">
          <XMarkIcon className="w-6 h-6 text-white" />
        </button>
      </div>
      <NewsletterSignUpPopup
        open={Boolean(showNewsletterPopup)}
        onClose={() => setShowNewsletterPopup(false)}
      />
    </>
  );
}
